/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {CheckpointDumpSaveReason} from './CheckpointDumpSaveReason';
import {
  CheckpointDumpSaveReasonFromJSON,
  CheckpointDumpSaveReasonFromJSONTyped,
  CheckpointDumpSaveReasonToJSON
} from './CheckpointDumpSaveReason';

/**
 *
 * @export
 * @interface CheckpointDumpKey
 */
export interface CheckpointDumpKey {
  /**
   *
   * @type {number}
   * @memberof CheckpointDumpKey
   */
  calcNumber: number;
  /**
   *
   * @type {CheckpointDumpSaveReason}
   * @memberof CheckpointDumpKey
   */
  saveReason: CheckpointDumpSaveReason;
  /**
   *
   * @type {string}
   * @memberof CheckpointDumpKey
   */
  checkpointUuid: string;
}

/**
 * Check if a given object implements the CheckpointDumpKey interface.
 */
export function instanceOfCheckpointDumpKey(value: object): value is CheckpointDumpKey {
  if (!('calcNumber' in value) || value['calcNumber'] === undefined) return false;
  if (!('saveReason' in value) || value['saveReason'] === undefined) return false;
  if (!('checkpointUuid' in value) || value['checkpointUuid'] === undefined) return false;
  return true;
}

export function CheckpointDumpKeyFromJSON(json: any): CheckpointDumpKey {
  return CheckpointDumpKeyFromJSONTyped(json, false);
}

export function CheckpointDumpKeyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CheckpointDumpKey {
  if (json == null) {
    return json;
  }
  return {
    calcNumber: json['calc_number'],
    saveReason: CheckpointDumpSaveReasonFromJSON(json['save_reason']),
    checkpointUuid: json['checkpoint_uuid']
  };
}

export function CheckpointDumpKeyToJSON(value?: CheckpointDumpKey | null): any {
  if (value == null) {
    return value;
  }
  return {
    calc_number: value['calcNumber'],
    save_reason: CheckpointDumpSaveReasonToJSON(value['saveReason']),
    checkpoint_uuid: value['checkpointUuid']
  };
}
